import { useCallback } from "react";

import { useLazyQuery } from "@stadium/services/apollo-client";
import { useCreateSwagContext } from "@contexts/create-swag-context";
import { FETCH_DRAFT_CATALOG_SELECTED_PRODUCTS_PRESENCE } from "@graphql/queries/stores/catalog/fetch-draft-catalog-selected-products-presence";

const emptyObj = {};

const useDraftCatalogSelectedProductsPresence = () => {
  const { draftSwagData, setDraftCatalogSelectedProductsPresence } = useCreateSwagContext();
  const draftCatalogNumber = draftSwagData?.number;

  const [fetchSelectedProductsPresenceQuery, { loading }] = useLazyQuery(
    FETCH_DRAFT_CATALOG_SELECTED_PRODUCTS_PRESENCE,
    {
      fetchPolicy: "network-only",
    },
  );

  const fetchSelectedProductsPresence = useCallback(
    async (productIds) => {
      const normalizedProductIds = productIds.map((id) => Number(id)).filter(Boolean);

      if (!draftCatalogNumber || !normalizedProductIds.length) {
        setDraftCatalogSelectedProductsPresence(emptyObj);
        return emptyObj;
      }

      try {
        const { data } = await fetchSelectedProductsPresenceQuery({
          variables: {
            number: draftCatalogNumber,
            productIds: normalizedProductIds,
          },
        });
        setDraftCatalogSelectedProductsPresence(
          data?.draftCatalogSelectedProductsPresence || emptyObj,
        );
        return data?.draftCatalogSelectedProductsPresence || emptyObj;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        setDraftCatalogSelectedProductsPresence(emptyObj);
        return emptyObj;
      }
    },
    [
      draftCatalogNumber,
      fetchSelectedProductsPresenceQuery,
      setDraftCatalogSelectedProductsPresence,
    ],
  );

  return { loading, fetchSelectedProductsPresence };
};

export default useDraftCatalogSelectedProductsPresence;
